import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { ChatService } from 'src/app/services/chat.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-chat-report',
  templateUrl: './chat-report.page.html',
  styleUrls: ['./chat-report.page.scss'],
})
export class ChatReportPage implements OnInit {

  chatList: any[];
  chatListFiltered: any[];
  chatListLength: number;
  
  userList: any[];
  userListFiltered: any[];
  userListLength: number;

  usersWithChat: number[] = [];
  
  searchText: string = '';

  selectedCategory: number = 0;
  selectedType: string = 'all';
  userCategories: any[] = [];
  loadChat: number;

  selectedUser: any;
  selectedChat: any;

  user: any;

  loading: any = null;

  //GROUPS
  groupEdit: any = null;
  groupEditBackup: any = null;
  groupPictUpdated: boolean = false;

  firstLoad:boolean = true;

  pushAudio: HTMLAudioElement;

  constructor(
    private userService: UserService, 
    private chatService: ChatService, 
    private changeDetection: ChangeDetectorRef,
    private menuCtrl: MenuController,
    private route:ActivatedRoute) { 

    }

  ngOnInit() {

    console.log('NG ON INIT REPORT PAGE');

    this.menuCtrl.enable(true);

    this.initializeMessages();

    this.route.queryParams.subscribe((e) => {
      console.log('queryParams',e);
      if(e && e.chatId) {
        this.loadChat = parseInt(e.chatId);

        if (this.chatListFiltered && this.chatListFiltered.length > 0) {
          this.selectChat(this.chatListFiltered.find(c => c.id === this.loadChat));
          this.loadChat = null;
        }
      }
    });
  }

  initializeMessages() {

    if (this.userService.currentUser && this.userService.currentUser.id && this.userService.userCategories.length > 0) {

      this.chatList = [];
      this.userCategories = this.userService.userCategories;
      this.userService.currentUser$.subscribe(next => {
        console.log('USER CHANGES ON MESSAGES PAGE');
        this.user = next;

        if (this.user && this.user.id && this.firstLoad) {
          this.firstLoad = false;
          this.refreshChatList();
        }
      });
    }
    else{
      setTimeout(()=>this.initializeMessages(),1000);
    }
  }

  refreshChatList() {
    this.chatService.getAssistanceChats().subscribe(res => {
      if (!res.error) {

        this.userList = res.users;

        res.chats.forEach(c => {
          this.parseChatToList(c);
        });

        this.updateFilteredChatList();

        console.log('filtered lists', this.chatListFiltered, this.userListFiltered);

        if (res.createdChatId) {
          this.loadChat = res.createdChatId;
        }

        if (this.loadChat) {
          this.selectChat(this.chatListFiltered.find(c => c.id === this.loadChat));
          this.loadChat = null;
        }
      }
    });
  }

  parseChatToList(chat) {
    chat.customer = {};
    chat.agent = {};

    chat.users.forEach(u => {
      if (u) {
        let usr = this.userList.find(user => user.id === u.user_id);

        if (usr?.is_customer) {
          chat.customer = usr;
        }
        else if (u.enabled) {
          chat.agent = usr;
        }
      }
      
    });

    if (chat.customer?.id) {
      let idx = this.chatList.findIndex(c => c.id == chat.id);

      if (idx < 0) {
        this.chatList.push(chat);
      }
      else {
        this.chatList[idx] = chat;
      }
    }    
  }

  updateFilteredChatList() {

    let searchText = this.searchText.toLowerCase();
    this.chatListFiltered = this.chatList.filter(chat => {
      let txt = `${chat.customer.username}_${chat.customer.email}_${chat.customer.company_name}
        _${chat.agent.username}_${chat.agent.email}_${chat.agent.company_name}`;
      return (searchText == '' || txt.toLowerCase().indexOf(searchText) >= 0);
    }).sort((a, b) => {
      
      return (a.last_message?.created_at > b.last_message?.created_at ? -1 : 1);
    })
  }

  

  searchUsers(ev) {
    console.log('search', ev.target.value);
    this.searchText = ev.target.value.toLowerCase();
    this.updateFilteredChatList();
  }

  selectChat(chat) {
    //this.selectedChat = Object.assign({}, chat);
    this.selectedChat = JSON.parse(JSON.stringify(chat));
    this.changeDetection.detectChanges();
  }

 
}
